// import React, { useState } from "react";
// import { NavLink } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Flex,
//   FormControl,
//   FormLabel,
//   Heading,
//   Input,
//   Text,
//   useColorModeValue,
//   useToast,
// } from "@chakra-ui/react";

// import DefaultAuth from "layouts/auth/Default";
// import illustration from "assets/img/auth/auth.jpg";

// // IMPORT FIREBASE SERVICES
// import { forgotPasswordService } from "../../../Service/AuthService";

// function ForgotPassword() {
//   const textColor = useColorModeValue("navy.700", "white");
//   const textColorSecondary = "gray.400";
//   const textColorBrand = useColorModeValue("brand.500", "white");
//   const brandStars = useColorModeValue("brand.500", "brand.400");
//   const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
//   const successBgColor = useColorModeValue("green.50", "green.900");
//   const successTextColor = useColorModeValue("green.700", "green.200");
//   const successSubTextColor = useColorModeValue("green.600", "green.300");

//   const [email, setEmail] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);

//   const toast = useToast();

//   // Function to convert Firebase error codes to user-friendly messages
//   const getErrorMessage = (errorCode) => {
//     const errorMessages = {
//       "auth/invalid-email": "Please enter a valid email address.",
//       "auth/user-not-found": "No account found with this email address. Please check your email or sign up for a new account.",
//       "auth/user-disabled": "This account has been disabled. Please contact support for assistance.",
//       "auth/too-many-requests": "Too many password reset attempts. Please try again later.",
//       "auth/network-request-failed": "Network error. Please check your internet connection and try again.",
//       "auth/missing-email": "Please enter your email address.",
//       "auth/internal-error": "An unexpected error occurred. Please try again.",
//       "auth/expired-action-code": "This password reset link has expired. Please request a new one.",
//       "auth/invalid-action-code": "This password reset link is invalid. Please request a new one.",
//     };

//     return errorMessages[errorCode] || "Unable to send password reset email. Please try again or contact support.";
//   };

//   const handleForgotPassword = async () => {
//     if (!email) {
//       toast({
//         title: "Email Required",
//         description: "Please enter your email address to continue.",
//         status: "warning",
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     // Basic email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(email)) {
//       toast({
//         title: "Invalid Email",
//         description: "Please enter a valid email address.",
//         status: "error",
//         duration: 3000,
//         isClosable: true,
//       });
//       return;
//     }

//     setLoading(true);
//     const res = await forgotPasswordService(email);
//     setLoading(false);

//     if (res.success) {
//       setSuccess(true);
//       toast({
//         title: "Reset Email Sent!",
//         description: "Check your inbox for instructions to reset your password. Don't forget to check your spam folder.",
//         status: "success",
//         duration: 6000,
//         isClosable: true,
//       });
//     } else {
//       // Extract error code from Firebase error string
//       let errorCode = res.error;
      
//       // If error is in format "Firebase: Error (auth/error-code)." extract the code
//       const match = res.error.match(/\(([^)]+)\)/);
//       if (match) {
//         errorCode = match[1];
//       }

//       const userFriendlyMessage = getErrorMessage(errorCode);

//       toast({
//         title: "Unable to Send Reset Email",
//         description: userFriendlyMessage,
//         status: "error",
//         duration: 4000,
//         isClosable: true,
//       });
//     }
//   };

//   // Handle Enter key press
//   const handleKeyPress = (e) => {
//     if (e.key === "Enter") {
//       handleForgotPassword();
//     }
//   };

//   return (
//     <DefaultAuth illustrationBackground={illustration} image={illustration}>
//       <Flex
//         maxW={{ base: "100%", md: "max-content" }}
//         w="100%"
//         mx={{ base: "auto", lg: "0px" }}
//         me="auto"
//         h="100%"
//         alignItems="start"
//         justifyContent="center"
//         mb={{ base: "30px", md: "60px" }}
//         px={{ base: "25px", md: "0px" }}
//         mt={{ base: "40px", md: "14vh" }}
//         flexDirection="column"
//       >
//         <Box me="auto">
//           <Heading color={textColor} fontSize="36px" mb="10px">
//             Forgot Password
//           </Heading>
//           <Text mb="36px" ms="4px" color={textColorSecondary}>
//             {success 
//               ? "We've sent you an email with reset instructions"
//               : "Enter your email and we'll send you a reset link"
//             }
//           </Text>
//         </Box>

//         {!success ? (
//           <Flex
//             direction="column"
//             w={{ base: "100%", md: "420px" }}
//             maxW="100%"
//             background="transparent"
//             borderRadius="15px"
//           >
//             {/* Email */}
//             <FormControl mb="20px">
//               <FormLabel color={textColor} fontSize="sm" fontWeight="500">
//                 Email<Text as="span" color={brandStars}>*</Text>
//               </FormLabel>
//               <Input
//                 type="email"
//                 variant="auth"
//                 placeholder="you@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 onKeyPress={handleKeyPress}
//                 size="lg"
//                 autoFocus
//               />
//             </FormControl>

//             {/* RESET BUTTON */}
//             <Button
//               fontSize="sm"
//               variant="brand"
//               w="100%"
//               h="50px"
//               mb="24px"
//               isLoading={loading}
//               onClick={handleForgotPassword}
//             >
//               Send Reset Link
//             </Button>

//             <Text color={textColorDetails} fontSize="14px">
//               Remember your password?
//               <NavLink to="/auth/sign-in">
//                 <Text as="span" color={textColorBrand} ms="5px" fontWeight="500">
//                   Sign In
//                 </Text>
//               </NavLink>
//             </Text>
//           </Flex>
//         ) : (
//           <Flex
//             direction="column"
//             w={{ base: "100%", md: "420px" }}
//             maxW="100%"
//             background="transparent"
//             borderRadius="15px"
//           >
//             <Box
//               p="20px"
//               bg={successBgColor}
//               borderRadius="10px"
//               mb="20px"
//             >
//               <Text color={successTextColor} fontSize="sm">
//                 ✓ A password reset link has been sent to <strong>{email}</strong>
//               </Text>
//               <Text color={successSubTextColor} fontSize="xs" mt="10px">
//                 The link will expire in 1 hour. If you don't see the email, check your spam folder.
//               </Text>
//             </Box>

//             <Button
//               fontSize="sm"
//               variant="outline"
//               colorScheme="brand"
//               w="100%"
//               h="50px"
//               mb="15px"
//               onClick={() => {
//                 setSuccess(false);
//                 setEmail("");
//               }}
//             >
//               Send Another Reset Link
//             </Button>

//             <Button
//               fontSize="sm"
//               variant="brand"
//               w="100%"
//               h="50px"
//               mb="24px"
//               onClick={() => window.location.href = "/auth/sign-in"}
//             >
//               Back to Sign In
//             </Button>
//           </Flex>
//         )}
//       </Flex>
//     </DefaultAuth>
//   );
// }

// export default ForgotPassword;
// views/auth/ForgotPassword.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";

import DefaultAuth from "layouts/auth/Default";
import illustration from "assets/img/auth/auth.jpg";

// IMPORT FIREBASE SERVICES
import { forgotPasswordService, checkAdminEmail } from "../../../Service/AuthService";

function ForgotPassword() {
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const successBgColor = useColorModeValue("green.50", "green.900");
  const successTextColor = useColorModeValue("green.700", "green.200");
  const successSubTextColor = useColorModeValue("green.600", "green.300");

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const toast = useToast();

  // Function to convert Firebase error codes to user-friendly messages
  const getErrorMessage = (errorCode) => {
    const errorMessages = {
      "auth/invalid-email": "Please enter a valid email address.",
      "auth/user-not-found": "No account found with this email address. Please check your email or sign up for a new account.",
      "auth/user-disabled": "This account has been disabled. Please contact support for assistance.",
      "auth/too-many-requests": "Too many password reset attempts. Please try again later.",
      "auth/network-request-failed": "Network error. Please check your internet connection and try again.",
      "auth/missing-email": "Please enter your email address.",
      "auth/internal-error": "An unexpected error occurred. Please try again.",
      "auth/expired-action-code": "This password reset link has expired. Please request a new one.",
      "auth/invalid-action-code": "This password reset link is invalid. Please request a new one.",
    };

    return errorMessages[errorCode] || "Unable to send password reset email. Please try again or contact support.";
  };

  const handleForgotPassword = async () => {
    if (!email) {
      toast({
        title: "Email Required",
        description: "Please enter your email address to continue.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    
    // Check if email exists in admin collection
    try {
      const isAdminEmail = await checkAdminEmail(email);
      
      if (!isAdminEmail) {
        setLoading(false);
        toast({
          title: "Permission Denied",
          description: "Only authorized admin emails can reset their password.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
    } catch (error) {
      setLoading(false);
      toast({
        title: "Verification Error",
        description: "Unable to verify email permissions. Please try again later.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    
    // Proceed with password reset if email exists in admin collection
    const res = await forgotPasswordService(email);
    setLoading(false);

    if (res.success) {
      setSuccess(true);
      toast({
        title: "Reset Email Sent!",
        description: "Check your inbox for instructions to reset your password. Don't forget to check your spam folder.",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    } else {
      // Extract error code from Firebase error string
      let errorCode = res.error;
      
      // If error is in format "Firebase: Error (auth/error-code)." extract the code
      const match = res.error.match(/\(([^)]+)\)/);
      if (match) {
        errorCode = match[1];
      }

      const userFriendlyMessage = getErrorMessage(errorCode);

      toast({
        title: "Unable to Send Reset Email",
        description: userFriendlyMessage,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleForgotPassword();
    }
  };

  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "0px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Forgot Password
          </Heading>
          <Text mb="36px" ms="4px" color={textColorSecondary}>
            {success 
              ? "We've sent you an email with reset instructions"
              : "Enter your email and we'll send you a reset link"
            }
          </Text>
        </Box>

        {!success ? (
          <Flex
            direction="column"
            w={{ base: "100%", md: "420px" }}
            maxW="100%"
            background="transparent"
            borderRadius="15px"
          >
            {/* Email */}
            <FormControl mb="20px">
              <FormLabel color={textColor} fontSize="sm" fontWeight="500">
                Email<Text as="span" color={brandStars}>*</Text>
              </FormLabel>
              <Input
                type="email"
                variant="auth"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyPress={handleKeyPress}
                size="lg"
                autoFocus
              />
            </FormControl>

            {/* RESET BUTTON */}
            <Button
              fontSize="sm"
              variant="brand"
              w="100%"
              h="50px"
              mb="24px"
              isLoading={loading}
              onClick={handleForgotPassword}
            >
              Send Reset Link
            </Button>

            <Text color={textColorDetails} fontSize="14px">
              Remember your password?
              <NavLink to="/auth/sign-in">
                <Text as="span" color={textColorBrand} ms="5px" fontWeight="500">
                  Sign In
                </Text>
              </NavLink>
            </Text>
          </Flex>
        ) : (
          <Flex
            direction="column"
            w={{ base: "100%", md: "420px" }}
            maxW="100%"
            background="transparent"
            borderRadius="15px"
          >
            <Box
              p="20px"
              bg={successBgColor}
              borderRadius="10px"
              mb="20px"
            >
              <Text color={successTextColor} fontSize="sm">
                ✓ A password reset link has been sent to <strong>{email}</strong>
              </Text>
              <Text color={successSubTextColor} fontSize="xs" mt="10px">
                The link will expire in 1 hour. If you don't see the email, check your spam folder.
              </Text>
            </Box>

            <Button
              fontSize="sm"
              variant="outline"
              colorScheme="brand"
              w="100%"
              h="50px"
              mb="15px"
              onClick={() => {
                setSuccess(false);
                setEmail("");
              }}
            >
              Send Another Reset Link
            </Button>

            <Button
              fontSize="sm"
              variant="brand"
              w="100%"
              h="50px"
              mb="24px"
              onClick={() => window.location.href = "/auth/sign-in"}
            >
              Back to Sign In
            </Button>
          </Flex>
        )}
      </Flex>
    </DefaultAuth>
  );
}

export default ForgotPassword;